import { useDeepCompareEffect } from 'react-use';
import { useSelector } from 'react-redux';
import { deepCompare, isRecordEmpty, objectIndexFromStringArray, removeUndefinedValues, } from 'hx-util';
/**
 * Used to update a forms values whenever the store is updated.
 *
 * @remarks
 * Only use when one way updating is intended. Otherwise use {@link useSyncFormWithStore}.
 *
 * @param form The form to update
 * @param storeFormIndex The index of the form in the store
 *
 * @example
 * import { useFormUpdater, useSyncFormWithStore } from 'hx-wizard';
 *
 * const form = useForm();
 * useFormUpdater(form, ['forms', 'myForm']);
 *
 */
export var useFormUpdater = function (form, storeFormIndex) {
    var setValue = form.setValue, getValues = form.getValues;
    var storeForm = useSelector(function (state) { return objectIndexFromStringArray(state, storeFormIndex) || {}; });
    useDeepCompareEffect(function () {
        var newValue = removeUndefinedValues(storeForm);
        if (isRecordEmpty(newValue))
            return;
        if (deepCompare(getValues(), newValue))
            return;
        var setValueToKey = function (_a) {
            var key = _a[0], value = _a[1];
            if (value == null)
                return;
            setValue(key, value, { shouldDirty: false });
        };
        Object.entries(storeForm).forEach(setValueToKey);
    }, [storeForm]);
};
export default useFormUpdater;
